import {ApiService} from '@/api/api-service';
import {
  ChangeEmailForm,
  ChangeEmailRequestForm,
  ChangePasswordForm, ConfirmEmail,
  ForgotPasswordForm,
  ResetPasswordForm,
  SignInForm,
  SignUpForm,
} from '@/models/account';

export class AccountApi {
  private readonly accountBaseUrl = '/api/account';

  public async signIn(formData: SignInForm): Promise<void> {
    await ApiService.post(
      `${this.accountBaseUrl}/sign-in`,
      formData,
    );
  }

  public async signOut(): Promise<void> {
    await ApiService.post(
      `${this.accountBaseUrl}/sign-out`,
      null,
    );
  }

  public async signUp(formData: SignUpForm): Promise<void> {
    await ApiService.post(
      `${this.accountBaseUrl}/sign-up`,
      formData,
    );
  }

  public async forgotPassword(formData: ForgotPasswordForm): Promise<void> {
    await ApiService.post(
      `${this.accountBaseUrl}/forgot-password`,
      formData,
    );
  }

  public async resetPassword(formData: ResetPasswordForm): Promise<void> {
    await ApiService.post(
      `${this.accountBaseUrl}/reset-password`,
      formData,
    );
  }

  public async changePassword(formData: ChangePasswordForm): Promise<void> {
    await ApiService.post(
      `${this.accountBaseUrl}/change-password`,
      formData,
    );
  }

  public async requestForChangeEmail(formData: ChangeEmailRequestForm): Promise<void> {
    await ApiService.post(
      `${this.accountBaseUrl}/request-change-email`,
      formData,
    );
  }

  public async changeEmail(formData: ChangeEmailForm): Promise<void> {
    await ApiService.post(
      `${this.accountBaseUrl}/change-email`,
      formData,
    );
  }

  public async confirmEmail(formData: ConfirmEmail): Promise<void> {
    await ApiService.post(
      `${this.accountBaseUrl}/confirm-email`,
      formData,
    );
  }

  public async confirmNewEmail(formData: ConfirmEmail): Promise<void> {
    await ApiService.post(
      `${this.accountBaseUrl}/confirm-email`,
      formData,
    );
  }
}
